import { FESTIVAL_TAB_VALUES } from './consts';

export const route = {
  ACCOUNT_SETTINGS: '/account-settings',
  ACCOUNT_SUBSCRIPTIONS: '/account-subscription',
  ARTICLES: '/articles',
  ARTISTS: '/artists',
  CASTING_TOOL: '/casting',
  COMPANIES: '/companies',
  COMPETITIONS: '/competitions',
  COMPOSERS: '/composers',
  CONTACT_OB: '/contact',
  COOKIE_POLICY: '/cookpol',
  DYNAMIC_ID_ROUTE: rootRoute => `${rootRoute}/[id]`,
  FESTIVALS: '/festivals',
  HIGHLIGHTS: '/highlights',
  HOME: '/',
  INTRO_AGENTS: '/proagent',
  INTRO_AOS: '/pro',
  INTRO_ARCHIVES: '/',
  INTRO_ARTISTS: '/proartist',
  INTRO_OB: '/intro',
  JOURNALISTS_AND_RESEARCH: '/journalist-and-research', // TODO change on real
  LIBRARY: '/library',
  LOGIN: '/login',
  MANAGERS: '/managers',
  MAPS: '/maps',
  NEW_RARE: '/new-and-rare',
  ON_THESE_DAY: '/onthisday',
  PAYMENT: '/payment',
  PRIVACY: '/privpol',
  PRODUCTIONS: '/productions',
  REGISTER: '/register',
  RENTALS: '/rentals',
  RESET_PASSWORD: '/login/reset',
  SEASONS: '/seasons',
  SECURITY: '/security',
  STATISTICS: '/statistics',
  STATS_NUMBERS: '/stats/numbers',
  TERMS_AND_CONDITIOS: '/termpol',
  VENUES: '/venues',
  WORK_WITH_OB: '/',
  WORKS: '/works',
  PAYMENT_TERMS: '/payment-terms',
  LOGOUT: '/logout',
};

export const actionsPagesRoutes = {
  ADD_ARTIST_TO_ROSTER: 'agency_artist_add',
  ADD_AGREEMENTS: 'agency_single_artist_updt',
  EDIT_AGENCY: 'agency_modif',
};

export const companiesPaths = {
  country: `${route.COMPANIES}/[country]`,
  company: `${route.COMPANIES}/[country]/[id]/[[...action]]`,
  edit: `${route.COMPANIES}/[country]/[id]/edit`,
  addProduction: `${route.COMPANIES}/[country]/[id]/edit/modify-production`,
};

export const festivalPaths = {
  view: `${route.FESTIVALS}/[year]/[country]/[id]`,
  edit: `${route.FESTIVALS}/[year]/[country]/[id]/edit`,
  modifyProduction: `${route.FESTIVALS}/[year]/[country]/[id]/edit/modify-production`,
  contact: `${route.FESTIVALS}/[year]/[country]/[id]/${FESTIVAL_TAB_VALUES.CONTACT}`,
  venues: `${route.FESTIVALS}/[year]/[country]/[id]/${FESTIVAL_TAB_VALUES.VENUES}`,
  about: `${route.FESTIVALS}/[year]/[country]/[id]/${FESTIVAL_TAB_VALUES.ABOUT}`,
  performances: `${route.FESTIVALS}/[year]/[country]/[id]/${FESTIVAL_TAB_VALUES.PERFORMANCES}`,
};

export const artistsPaths = {
  id: `${route.ARTISTS}/[id]`,
  edit: `${route.ARTISTS}/[id]/edit`,
  modifyProduction: `${route.ARTISTS}/[id]/edit/modify-production`,
  searchProductions: `${route.ARTISTS}/[id]/edit/search-productions`,
  photos: `${route.ARTISTS}/[id]/photos`,
  videos: `${route.ARTISTS}/[id]/videos`,
  repertoire: `${route.ARTISTS}/[id]/repertoire`,
  reviews: `${route.ARTISTS}/[id]/reviews`,
  bio: `${route.ARTISTS}/[id]/bio`,
};

export const venuePaths = {
  venue: `${route.VENUES}/[country]/[id]/[[...action]]`,
};

export default route;
